import { colors } from './index'
import configureStore from '../configureStore'
import convertStyleWithMultiplier from './styleHelper'

export const textStylesObj = {
  blueMediumText: {
    color: colors.bscBlue,
    fontSize: 21,
    fontWeight: 'normal',
    lineHeight: 25,
  },
  boldBlueTitle: {
    color: colors.bscBlue,
    fontSize: 18,
    fontWeight: '700',
  },
  bodyContentText: {
    color: colors.shark_grey,
    fontSize: 16,
    lineHeight: 22,
    marginBottom: 16,
  },
  bodyContentTextBold: {
    color: colors.shark_grey,
    fontSize: 16,
    fontWeight: 'bold',
    lineHeight: 22,
    marginBottom: 16,
  },
  bodyContentTextNoMargin: {
    color: colors.shark_grey,
    fontSize: 16,
    lineHeight: 22,
  },
  bodyContentWhiteText: {
    color: colors.white,
    fontSize: 16,
    fontWeight: 'normal',
    marginBottom: 16,
    marginLeft: 16,
    marginRight: 16,
  },
  bodyContentWhiteTextBold: {
    color: colors.white,
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 16,
  },
  detailText: {
    color: colors.shark_grey,
    fontSize: 16,
    lineHeight: 22,
  },
  h1: {
    fontSize: 24,
    fontWeight: 'bold',
  },
  faqH1Container: {
    marginLeft: 1,
    marginRight: 1,
    marginTop: 16,
    marginBottom: 8,
  },
  h1Container: {
    marginLeft: 16,
    marginRight: 16,
    marginTop: 16,
    marginBottom: 8,
  },
  h2: {
    fontSize: 20,
    lineHeight: 27.4,
    fontWeight: 'bold',
  },
  h3: {
    fontSize: 16,
    lineHeight: 27.3,
    fontWeight: 'bold',
  },
  mediumBoldBlueTitle: {
    color: colors.bscBlue,
    fontSize: 18,
    fontWeight: 'bold',
  },
  bscResearchTitle: {
    color: colors.shark_grey,
    fontSize: 20,
    fontWeight: 'bold',
    lineHeight: 22,
    marginBottom: 16,
    marginTop: 16,
  },
  bscResearchText: {
    color: colors.shark_grey,
    fontSize: 16,
    lineHeight: 19,
    paddingBottom: 16,
  },
}

const Sheet = () => {
  const { storedData } = configureStore.getState()
  const { fontMultiplier } = storedData
  return convertStyleWithMultiplier(fontMultiplier || 1, textStylesObj)
}

export default Sheet()
